import { useNavigate } from 'react-router-dom';
import { CH, I, IconBtn } from './MobileAppHeader';

const MenuRow = ({ icon, label, sublabel, onClick, danger }) => (
  <div
    onClick={onClick}
    style={{
      display: 'flex', alignItems: 'center', gap: 14,
      padding: '14px 20px',
      borderBottom: '1px solid var(--app-color-border)',
      cursor: 'pointer',
    }}
  >
    <div style={{
      width: 36, height: 36, borderRadius: 10, flexShrink: 0,
      background: danger ? '#fff0ee' : 'var(--app-color-surface)',
      border: `1px solid ${danger ? '#f5c6c0' : 'var(--app-color-border)'}`,
      color: danger ? '#c03727' : CH.muted,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 16,
    }}>{icon}</div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 14, color: danger ? '#c03727' : CH.ink, fontWeight: 500 }}>{label}</div>
      {sublabel && <div style={{ fontSize: 11, color: CH.dim, fontFamily: CH.mono, marginTop: 1 }}>{sublabel}</div>}
    </div>
    {!danger && <span style={{ color: CH.dim, fontSize: 14 }}>{I.chevR}</span>}
  </div>
);

function MobileSettingsScreen({ user, onLogout }) {
  const navigate = useNavigate();

  const email = user?.signInDetails?.loginId ?? user?.username ?? '';
  const initial = (email[0] ?? '?').toUpperCase();

  return (
    <div style={{ background: 'var(--mantine-color-body)', minHeight: '100vh', fontFamily: CH.serif, paddingBottom: 40 }}>
      <div style={{
        position: 'sticky', top: 0, zIndex: 20,
        background: 'var(--mantine-color-body)',
        borderBottom: '1px solid var(--app-color-border)',
        padding: '8px 16px',
        display: 'flex', alignItems: 'center', gap: 8, minHeight: 48,
      }}>
        <IconBtn onClick={() => navigate(-1)}>{I.back}</IconBtn>
        <span style={{ fontSize: 14, fontWeight: 500, color: CH.ink }}>設定</span>
      </div>

      {/* プロフィール */}
      <div style={{ padding: '28px 20px 20px', display: 'flex', alignItems: 'center', gap: 16 }}>
        <div style={{
          width: 56, height: 56, borderRadius: 28, flexShrink: 0,
          background: '#c96442', color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 22, fontWeight: 500,
        }}>{initial}</div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 500, color: CH.ink, marginBottom: 2 }}>アカウント</div>
          <div style={{ fontSize: 12, color: CH.muted, fontFamily: CH.mono, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{email}</div>
        </div>
      </div>

      {/* メニュー */}
      <div style={{ margin: '0 16px', background: 'var(--app-color-surface)', border: '1px solid var(--app-color-border)', borderRadius: 10, overflow: 'hidden' }}>
        <MenuRow
          icon={I.award}
          label="Certifications"
          sublabel="資格一覧・ステータス管理"
          onClick={() => navigate('/Certifications')}
        />
        <MenuRow
          icon={I.logout}
          label="ログアウト"
          onClick={onLogout}
          danger
        />
      </div>

    </div>
  );
}

export default MobileSettingsScreen;
